import { TxpObject } from 'txp-data';
import InferredEntityIds from '../../store/schema/InferredEntityIds';
import InferredIds from '../../store/schema/InferredIds';

export default function getInferredEntityIds(txpObject: TxpObject): InferredEntityIds {
    let inferredIds: InferredIds[] = [];
    if (txpObject && txpObject.txpEntities) {
        Object.values(txpObject.txpEntities).map(entity => {
            if (entity.inferenceId) {
                let entityIndex = -1;

                inferredIds.map((inferredId, index) => {
                    if (inferredId.EntityType == entity.entityName) {
                        entityIndex = index;
                    }
                });

                if (entityIndex > -1) {
                    if (
                        inferredIds[entityIndex].InferredEntityIds.indexOf(entity.inferenceId) == -1
                    ) {
                        inferredIds[entityIndex].InferredEntityIds.push(entity.inferenceId);
                    }
                } else {
                    inferredIds.push({
                        EntityType: entity.entityName,
                        InferredEntityIds: [entity.inferenceId],
                    } as InferredIds);
                }
            }
        });

        if (inferredIds.length > 0) {
            const inferredEntityIds: InferredEntityIds = {
                InferredIds: inferredIds,
            };

            return inferredEntityIds;
        }
    }

    return null;
}
